<div class="container">

    <span class="servicios-title">Servicios Disponibles</span>
    <div class="servicios-container">
        <div *ngFor="let item of servicios" class="servicios-item" (click)="abrirHistorial(item.servicioSkuId, item.descripcion)">

            <img src="{{item.img}}"/>
            <span style="font-weight: bold; font-size: 13px;">{{item.label}}</span>
            <span class="badge me-1 fs-14px" [ngClass]="{'bg-danger': item.cantidadDisponible ===  0, 'bg-green': item.cantidadDisponible ===  item.cantidadTotal, 'bg-warning': item.cantidadDisponible > 0 && item.cantidadDisponible < item.cantidadTotal}">{{item.cantidadDisponible}} / {{item.cantidadTotal}}</span>
        </div>
    </div>

    <div *ngIf="ppCaducado" class="ppcaducado-container">
        <i class="fa-regular fa-circle-xmark fs-44px"></i>
        <span class="fs-16px mt-2">¡No puedes redimir servicios!</span>
        <span class="fs-12px mt-1">Vigencia del Plan Protection expirada por Kilometraje.</span>
    </div>
    <div *ngIf="!ppCaducado" class="svg-wrapper mt-2 mb-2" [class.editing-mode]="isEditing">
        <svg 
        #svgRef
        viewBox="0 0 600 700"
        preserveAspectRatio="xMidYMid meet"
        (mousemove)="onMove($event)"
        (touchmove)="onMove($event)"
        (mouseup)="endDrag()"
        (touchend)="endDrag()"
        (mouseleave)="endDrag()">
            
            <image href="assets/carro.jpg" x="0" y="0" width="600" height="700" />

            <g *ngFor="let zone of zones" 
                [attr.transform]="'translate(' + zone.x + ',' + zone.y + ')'"
                (mousedown)="startDrag($event, zone)"
                (touchstart)="startDrag($event, zone)"
                style="pointer-events: all;">

                <circle 
                    [attr.cx]="zone.cx" 
                    [attr.cy]="zone.cy" 
                    [attr.r]="zone.radius" 
                    class="zone-rect" 
                    [ngClass]="{'selected': getZoneSelected(zone)}"
                    [class.editable]="isEditing" 
                    (click)="toggleZone(zone, $event)" 
                    (touchend)="handleTap(zone, $event)"> 
                </circle>
           
            </g>
        </svg>
    </div>

    <div *ngIf="!ppCaducado" class="w-100 d-flex flex-row justify-content-between">
        <button class="btn btn-light fs-12px text-black" style="border: 1px solid black;" (click)="abrirDetalleSku()"><b>Info. Llanta</b> <img src="../../../assets/icons/llantas.webp" class="ms-2" style="width: 20px;" alt=""></button>
        <button class="btn btn-primary fs-12px" (click)="abrirCarrito()"><b>Ver Serv. Seleccionados</b> <i class="fa-solid fa-cart-shopping ms-2"></i></button>
    </div>
</div>
